'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { HtmlRendererRaw } from '@eliadmin/core/src/components/ui/html-renderer-raw';

interface HeadingProps {
  title: string;
  center?: boolean;
  uppercase?: boolean;
  className?: {
    title?: string;
    subtitle?: string;
    container?: string;
    vector?: string;
  };
  color?: 'white' | 'black';
  subtitle?: string;
  tag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  /** Change semantics without changing the existing tag-based visual selectors. */
  semanticTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'span';
  /** Visual size when it should differ from the semantic tag (e.g. an h1 styled as h4). */
  styleAs?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function Heading({
  title,
  className,
  tag = 'h2',
  styleAs,
  semanticTag,
  center = false,
  color = 'black',
  uppercase = false,
  subtitle,
}: HeadingProps) {
  const Tag = semanticTag ?? tag;

  return (
    <div
      className={cn(
        'ea-heading__container',
        'flex flex-col items-start justify-start',
        className?.container,
        center && 'items-center justify-center text-center',
        subtitle && 'gap-4 sm:gap-5 lg:gap-6',
      )}
    >
      {!!subtitle && (
        <p
          className={cn(
            'flex h-[25px] items-center justify-center bg-[#EFF4FF] px-2 text-xs font-bold uppercase text-black sm:h-[28px] sm:text-sm',
            'ea-heading__subtitle',
            'font-heading',
            className?.subtitle,
          )}
        >
          {subtitle}
        </p>
      )}
      <HtmlRendererRaw
        as={Tag}
        data-ea-visual-tag={semanticTag ? tag : undefined}
        className={cn(
          'relative z-[5] text-left font-semibold tracking-tighter text-black',
          color === 'white' && 'text-white',
          center && 'text-center',
          uppercase && 'uppercase',
          styleAs ?? tag,
          className?.title,
          'ea-heading__title',
        )}
        html={title}
      />
    </div>
  );
}
